export default __webpack_public_path__ + "static/media/Background-v1.82194c79.png";